import cx from 'classnames'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { PriceConverter } from '../../../../helpers'
import DateFormat from '../../../../helpers/DateFormat'
import messages from '../../../../account/booking-details/translations'
import Card from '../shared/Card'
import QuoteIncludesCollapsible from './QuoteIncludesCollapsible'
import styles from './TripSummaryCard.module.scss'

TripSummaryCard.propTypes = {
  order: PropTypes.object.isRequired,
  onCouponRemove: PropTypes.func,
  onVoucherAdd: PropTypes.func,
  dueNowData: PropTypes.object,
}

export default function TripSummaryCard({
  order,
  onCouponRemove,
  onVoucherAdd,
  dueNowData,
}) {
  const intl = useIntl()
  const [open, setOpen] = useState(false)
  const { dateFrom, dateTo, duration, pax, amountTotal, currency } = order

  return (
    <Card className={styles.card}>
      <p className={styles.title}>
        <FormattedMessage
          id='select_your_cabin'
          defaultMessage='Select your cabin'
        />
      </p>
      <div className={styles.statsRow}>
        <span className={styles.stat}>
          <span><FormattedMessage id='Start' defaultMessage='Start:' /></span>
          <DateFormat date={dateFrom} format='DD MMMM YYYY' />
        </span>
        <span className={styles.stat}>
          <span><FormattedMessage id='end' defaultMessage='End:' /></span>
          <DateFormat date={dateTo} format='DD MMMM YYYY' />
        </span>
        <span className={styles.stat}>
          <span><FormattedMessage id='duration' defaultMessage='Duration:' /></span>
          {intl.formatMessage(messages.nightsPlural, { qty: duration })}
        </span>
        <span className={styles.stat}>
          <span><FormattedMessage id='guests' defaultMessage='Number of Guests:' /></span>
          {intl.formatMessage(messages.guestsPlural, { qty: pax })}
        </span>
      </div>
      <div className={styles.summaryRow}>
        <button
          type='button'
          className={cx(styles.collapseTrigger, { [styles.open]: open })}
          onClick={() => setOpen((o) => !o)}
        >
          <FormattedMessage
            id='quote_includes'
            defaultMessage='Your quote includes'
          />
          <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' width='24' height='24' aria-hidden='true' className={styles.chevron}>
            <path strokeLinecap='round' strokeLinejoin='round' d='M19.5 8.25l-7.5 7.5-7.5-7.5' />
          </svg>
        </button>
        <span className={styles.totalPrice}>
          <FormattedMessage id='total_price' defaultMessage='Total Price:' />
          <PriceConverter amount={amountTotal} currency={currency} />
        </span>
      </div>
      {open && (
        <QuoteIncludesCollapsible
          order={order}
          onCouponRemove={onCouponRemove}
          onVoucherAdd={onVoucherAdd}
          dueNowData={dueNowData}
        />
      )}
    </Card>
  )
}
